import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

// This component was inspired by this article. https://medium.com/hackernoon/using-a-react-16-portal-to-do-something-cool-2a2d627b0202

function copyStyles(sourceDoc, targetDoc) {
  Array.from(sourceDoc.styleSheets).forEach((styleSheet) => {
    const styleElement = sourceDoc.createElement('style');
    Array.from(styleSheet.cssRules).forEach((cssRule) => {
      styleElement.appendChild(sourceDoc.createTextNode(cssRule.cssText));
    });
    targetDoc.head.appendChild(styleElement);
  });
}

class TabLauncher extends React.PureComponent {
  constructor(props) {
    super(props);
    this.container = document.createElement('div'); // create a new container element to render child components inside
    this.newTab = null;
  }

  componentDidMount() {
    const { title } = this.props;
    /*
      The setTimeout call with 0 delay here is a workaround for a bug in react that throws "Should not already be working" errors in Firefox when calling js window functions inside the componentDidMount function
      See this github issue (issue is still open at the time this code was written) for more information: https://github.com/facebook/react/issues/17355
    */
    setTimeout(() => {
      // create a new browser tab, insert the new container element from the constructor, set the tab title and bring in styles from parent page.
      this.newTab = window.open();
      this.newTab.document.body.appendChild(this.container);
      this.newTab.document.title = title;
      if (!this.newTab || !this.newTab.document) {
        // eslint-disable-next-line no-alert
        window.alert('Please disable popup blocking to utilize tabs');
      } else {
        copyStyles(document, this.newTab.document);
      }
    }, 0);
  }

  render() {
    // Use ReactDOM Portals to render any child components inside the container created in the constructor.
    const { children } = this.props;
    return ReactDOM.createPortal(children, this.container);
  }
}

TabLauncher.propTypes = {
  children: PropTypes.element.isRequired,
  title: PropTypes.string,
};
TabLauncher.defaultProps = {
  title: `PremiSys\u00AE`,
};
export default TabLauncher;
